module.exports = __webpack_public_path__ + "static/img/home_img_1.74a54e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_img_1.png
// module id = W91Y
// module chunks = 0